import { GripVertical, Eye, EyeOff } from 'lucide-react';

// Widget wrapper component for drag and drop
export const WidgetWrapper = ({ 
  id, 
  children, 
  className = '',
  editMode,
  draggedWidget,
  dragOverWidget,
  hiddenWidgets,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragEnd,
  onToggleVisibility
}) => {
  const isDragging = draggedWidget === id;
  const isDragOver = dragOverWidget === id;
  const isHidden = hiddenWidgets.includes(id);
  
  return (
    <div
      draggable={editMode}
      onDragStart={(e) => onDragStart(e, id)}
      onDragOver={(e) => onDragOver(e, id)}
      onDragLeave={onDragLeave}
      onDrop={(e) => onDrop(e, id)}
      onDragEnd={onDragEnd}
      className={`relative ${className} ${editMode ? 'cursor-move' : ''} ${isDragging ? 'opacity-50' : ''} ${isDragOver ? 'ring-2 ring-blue-400 ring-offset-2' : ''} ${isHidden && editMode ? 'opacity-40' : ''} transition-all`}
    >
      {editMode && (
        <>
          {/* Drag handle */}
          <div className="absolute top-2 left-2 z-10 p-1 bg-gray-800/80 rounded-lg">
            <GripVertical className="w-5 h-5 text-white" strokeWidth={1.5} />
          </div>
          {/* Visibility toggle */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              onToggleVisibility(id);
            }}
            className={`absolute top-2 right-2 z-10 p-1.5 rounded-lg transition-colors ${
              isHidden 
                ? 'bg-red-500/80 hover:bg-red-600/80' 
                : 'bg-gray-800/80 hover:bg-gray-700/80'
            }`}
            title={isHidden ? 'Show widget' : 'Hide widget'}
            data-testid={`toggle-${id}`}
          >
            {isHidden ? (
              <EyeOff className="w-5 h-5 text-white" strokeWidth={1.5} />
            ) : (
              <Eye className="w-5 h-5 text-white" strokeWidth={1.5} />
            )}
          </button>
          {/* Hidden overlay */}
          {isHidden && (
            <div className="absolute inset-0 bg-gray-200/50 rounded-lg z-[5] flex items-center justify-center">
              <span className="bg-gray-800/80 text-white px-3 py-1 rounded-lg text-sm font-medium">
                Hidden
              </span>
            </div>
          )}
        </>
      )}
      {children}
    </div>
  );
};

export default WidgetWrapper;
